import cc from "classcat"

const H3 = ({
  children,
  textStyle = "dark",
  textAlign = "center",
  size = "medium",
}) => {
  return (
    <h3
      className={cc([
        "mt-2 whitespace-pre-line font-extrabold tracking-tight",
        {
          "text-white": textStyle === "light",
          "text-zinc-900": textStyle !== "light",
          "text-center": textAlign === "center",
          "text-left": textAlign === "left",
        },
        size === "medium" && "text-3xl leading-8 sm:text-4xl sm:leading-10",
        size === "large" && "text-4xl sm:text-5xl",
      ])}
    >
      {children}
    </h3>
  )
}

export default H3
